import React from 'react';
export function FantasyHeader({ blockName, }){
  const classPrefix = `${ blockName }__header`;
  return (
    <header
      className={ `${ classPrefix }` }
    >
      <div className={ `${ classPrefix }-logo-container` }></div>
      <div className={ `${ classPrefix }-label-starts-today` }
      >
        Starts Today
      </div>
    </header>
  );
}


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fantasy/components/fantasyHeader.js